import { useEffect } from 'react';
import {
  getCookieConsent,
  onCookieConsentChange,
  type ConsentValue,
} from '@/components/CookieConsentBanner';

/**
 * Loads analytics ONLY after the user has given consent.
 * Replace the loadAnalytics() body with your real provider (GA4, Plausible, etc.).
 *
 * Currently a no-op placeholder that just logs to console — no scripts are
 * injected and no cookies are set unless the user accepts.
 */

let analyticsLoaded = false;

const loadAnalytics = () => {
  if (analyticsLoaded) return;
  analyticsLoaded = true;
  // TODO: inject your real analytics script here, e.g.:
  // const s = document.createElement('script');
  // s.src = 'https://www.googletagmanager.com/gtag/js?id=G-XXXXXX';
  // s.async = true;
  // document.head.appendChild(s);
  // window.dataLayer = window.dataLayer || [];
  // function gtag(...args: any[]) { window.dataLayer.push(args); }
  // gtag('js', new Date()); gtag('config', 'G-XXXXXX');
  console.info('[analytics] consent granted — analytics would load here');
};

const unloadAnalytics = () => {
  // Best-effort: cannot unload an external script that already ran, but we can
  // mark the flag so we don't try again in this session.
  analyticsLoaded = false;
  console.info('[analytics] consent revoked / rejected — analytics disabled');
};

const apply = (consent: ConsentValue | null) => {
  if (consent === 'accepted') loadAnalytics();
  else unloadAnalytics();
};

const ConsentAwareAnalytics = () => {
  useEffect(() => {
    apply(getCookieConsent());
    const off = onCookieConsentChange((v) => apply(v));
    return off;
  }, []);
  return null;
};

export default ConsentAwareAnalytics;
